import { updateOrAddColumnOptionState, updateOrAddColumnTemplate, updateOrAddDatapointRequest } from "../../helpers";
import { ColumnSortOrder } from "components/ux/ins-multi-column-sort/types";
export const addOrUpdateMeasureForGrid = (state, action, componentProps) => {
    updateOrAddDatapointRequest(state, action.payload);
    const newColumnOption = updateOrAddColumnOptionState(state, action.payload);
    if (newColumnOption) {
        if (newColumnOption?.sequenceNumber === 0) {
            newColumnOption.sorted = true;
            newColumnOption.sortOrder = ColumnSortOrder.Ascending;
        }
        updateOrAddColumnTemplate(state, newColumnOption);
    }
    // For grids which are not using pipelineParameter compositeObjectBuilder automatic generation
    if (componentProps.pipelineParameter?.compositeObjectBuilder?.measures) {
        componentProps.pipelineParameter.compositeObjectBuilder.measures.push(action.payload.id);
    }
};
